<div class="mask"><div class="mask-content" :class="position" :style="contentStyle" @click.stop="nop"><slot></slot></div></div>